'use strict';

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');
var nocUtil = require('../../util/noc-util');
var messageFields = require('../../util/messageFields');


module.exports = /*@ngInject*/ function () {

    var MessageDataStructure = function (boxDiscriminationInfo, coachDiscriminationInfo, obisDiscriminationInfo) {
        "use strict";

        var self = this;
        // messages that use the MAR3 discrimination info (MAR3 discriptors based on box id and possibly Link)
        self.mar3MessageNames = ['mar3LinkStatistics', 'mar3LinkCombined', 'mar3LteStatistics', 'mar3GsmStatistics', 'mar3WcdmaStatistics', 'mar3LinkSessions', 'mar3Congestion', 'trainUsers', 'virtualUser', 'capacityTestData'];
        // messages that use the Coach discrimination info (discrimination based on coach id)
        self.coachMessageNames = ['connections'];
        // messages that use the Obis discrimination info (discrimination based on Obis device type)
        self.obisMessageNames = ['obisDeviceTemperature', 'obisDeviceLifeSign','obisDeviceLoopStatus','obisDevicePSUDetails','obisDevicePSUDetailsSummary','obisDeviceSWPlatformStatus','obisDeviceAssignedJourney','obisDeviceDegraded','obisMtsDownloadStatus', 'obisLine', 'obisDeviceOperationHours', 'obisTrainPosition', 'obisMmdBacklight'];

        self.enableApply = false;
         self.showNoData = false;

        var data = messageFields.getMessageFields();


        filterDiscriminators(data, boxDiscriminationInfo, self.mar3MessageNames);

        // don't filter for coach discrimination info if not provided
        if (arguments.length > 1) {
            filterDiscriminators(data, coachDiscriminationInfo, self.coachMessageNames);
        }
        
        // don't filter for obis discrimination info if not provided
        if (arguments.length > 2) {
            filterDiscriminators(data, obisDiscriminationInfo, self.obisMessageNames);
        }

        var currentState = {
            messageName: undefined,
            discriminator: undefined,
            subDiscriminator: undefined,
            config: undefined,
            aggregateLinks: false
        };

        self.getCurrentState = function () {
            return angular.copy(currentState);
        };

        self.setMessageName = function (name) {
            currentState.messageName = name;
            currentState.config = determineDiscriminatorConfig(name, self.mar3MessageNames, self.coachMessageNames);
            currentState.discriminator = undefined;
            currentState.subDiscriminator = undefined;
        };

        self.setDiscriminatorName = function (discriminator) {
            currentState.discriminator = discriminator;
            if (!self.hasSubDiscriminator()) {
                currentState.subDiscriminator = undefined;
            }
        };

        self.setSubDiscriminatorName = function (subDiscriminator) {
            currentState.subDiscriminator = subDiscriminator;
            self.setEnableApply();
        };

        self.setEnableApply = function () {
            var currentCheckedProperties = self.getCurrentCheckedProperties().filter(
                property => property.subDiscriminatorName === currentState.subDiscriminator
            );
            self.enableApply = currentCheckedProperties.length > 0;
        };

        self.getMessageData = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return data[messageName];
        };

        self.getData = function () {
            return data;
        };

        self.setData = function (newData) {
            if (data != newData) {
                angular.copy(newData, data);
            }
        };

        self.setCurrentState = function (state) {
            currentState.messageName = state.messageName;
            currentState.discriminator = state.discriminator;
            currentState.subDiscriminator = state.subDiscriminator;
            currentState.config = state.config;
            currentState.aggregateLinks = state.aggregateLinks;
        };

        self.toggleVlinkAggregation = function () {
            currentState.aggregateLinks = !currentState.aggregateLinks;
        };

        self.isVlinkAggregationEnabled = function () {
            if (!util.isDefined(currentState.aggregateLinks)) {
                currentState.aggregateLinks = false;
            }
            return currentState.aggregateLinks;
        };

        /**
         * Get the highest index that is already in use for the graph stacking.
         * The index determines the order in which the graphs are stacked.
         *
         * @param messages
         * @returns {number}
         */
        self.getMaxPropertyIndex = function (messages) {
            var maxIndex = -1;
            if (util.isDefined(messages)) {
                messages.forEach(function (message) {
                    var selectedProperties = self.getCheckedProperties(message);
                    selectedProperties.forEach(function (property) {
                        if (util.isDefined(property.index) && property.index > maxIndex) {
                            maxIndex = property.index;
                        }
                    });
                });
                return maxIndex;
            }
        };


        /**
         * Dedicate an index to each of the selected properties.
         * The max index is the highest used index before this method is called.
         *
         * @param maxIndex
         * @param selectedProperties
         */
        self.updatePropertyOrder = function (maxIndex, selectedProperties) {
            if (util.isDefined(maxIndex) && util.isDefined(selectedProperties)) {
                selectedProperties.forEach(function (property) {
                    if (!util.isDefined(property.index)) {
                        maxIndex++;
                        property.index = maxIndex;
                    }
                });
            }
        };

        /**
         * Optional parameters, if none is specified the function is applied on the currentState.
         * @param messageName
         * @returns {Array}
         */
        self.getDiscriminatorList = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return data[messageName].discriminators;
        };

        /**
         * Optional parameters, if none is specified the function is applied on the currentState.
         * @param messageName
         * @param discriminatorName
         * @returns {*|Array}
         */
        self.getSubDiscriminatorList = function (messageName, discriminatorName) {
            messageName = arguments.length === 2 ? messageName : currentState.messageName;
            var discriminators = self.getDiscriminatorList(messageName);
            //if no discriminator selected, get first in list. fall back procedure.
            discriminatorName = arguments.length === 2 ? discriminatorName : util.isDefined(self.getCurrentState().discriminator) ? self.getCurrentState().discriminator : discriminators[0].name;
            var subDiscriminators = arrayUtil.getFirstInList(discriminators, 'name', discriminatorName).subDiscriminators;

            if (util.isDefined(subDiscriminators) && self.shouldAggregateVlinks() && currentState.aggregateLinks) {
                subDiscriminators = nocUtil.removeVLinkSubDiscriminators(subDiscriminators);
            }
            return subDiscriminators;
        };

        /**
         * Optional parameters, if none is specified the function is applied on the currentState.
         * @param messageName
         * @param name
         * @returns {*}
         */
        self.getDiscriminator = function (messageName, name) {
            messageName = arguments.length === 2 ? messageName : currentState.messageName;
            name = arguments.length === 2 && util.isDefined(name) ? name : util.isDefined(currentState.discriminator) ? currentState.discriminator : self.getDiscriminatorList(messageName)[0].name;
            var discriminators = self.getDiscriminatorList(messageName);
            return arrayUtil.getFirstInList(discriminators, 'name', name);
        };

        /**
         * Optional parameters, if none is specified the function is applied on the currentState.
         * @param messageName
         * @param discriminatorName
         * @param name
         * @returns {*}
         */
        self.getSubDiscriminator = function (messageName, discriminatorName, name) {
            messageName = arguments.length === 3 ? messageName : currentState.messageName;
            discriminatorName = arguments.length === 3 ? discriminatorName : currentState.discriminator;
            name = arguments.length === 3 ? name : currentState.subDiscriminator;
            var discriminator = self.getDiscriminator(messageName, discriminatorName) && self.getDiscriminator(messageName, discriminatorName);
            if (!util.isDefined(discriminator)) {
                return undefined;
            }
            if (util.isDefined(name)) {
                return arrayUtil.getFirstInList(discriminator.subDiscriminators, 'name', name);
            } else {
                var firstOne = discriminator.subDiscriminators[0];
                self.setSubDiscriminatorName(firstOne.name);
                return firstOne;
            }
        };

        /**
         * Returns the list of properties for the given messageName, discriminatorName and sunDiscriminatorName
         * If the message does not have a discriminator or subDiscriminator, the names do not have to be specified.
         * @param messageName
         * @param discriminatorName
         * @param subDiscriminatorName
         * @returns {*}
         */
        self.getProperties = function (messageName, discriminatorName, subDiscriminatorName) {
            if (self.hasDiscriminator(messageName)) {
                if (self.hasSubDiscriminator(messageName)) {
                    var meta = self.getSubDiscriminator(messageName, discriminatorName, subDiscriminatorName);
                    if (util.isDefined(meta)) {
                        return meta.properties;
                    } else {
                        return undefined;
                    }
                } else {
                    return self.getDiscriminator(messageName, discriminatorName) && self.getDiscriminator(messageName, discriminatorName).properties;
                }
            } else {
                return data[messageName].properties;
            }
        };

        /**
         * Returns a list of properties for the current combination of messageName, discriminatorName and sunDiscriminatorName
         * @returns {*}
         */
        self.getCurrentProperties = function () {
            return self.getProperties(currentState.messageName, currentState.discriminator, currentState.subDiscriminator);
        };

        /**
         * Returns a list of the current checked properties.
         * The current properties are defined by the combination of of messageName, discriminatorName and sunDiscriminatorName
         */
        self.getCurrentCheckedProperties = function () {
            if (self.hasDiscriminator()) {
                if (self.hasSubDiscriminator()) {
                    return getCheckedPropertiesArrayForList(self.getSubDiscriminatorList(), 'subid', 'name');
                } else {
                    return getCheckedPropertiesArrayForList([self.getDiscriminator()], 'name');
                }
            } else {
                return data[currentState.messageName] ? getCheckedPropertiesFromList(data[currentState.messageName].properties) : [];
            }
        };

        self.getCurrentSingleCheckedProperties = function (messageName, descriminator, subDiscriminator) {
            var checkedProperty = undefined;
            if (self.hasDiscriminator()) {
                if (self.hasSubDiscriminator()) {
                    checkedProperty = arrayUtil.filterArray(self.getCurrentProperties(), 'checked', true);
                    if (arrayUtil.isNotEmptyArray(checkedProperty)) {
                        checkedProperty = checkedProperty[0];
                        checkedProperty['discriminatorName'] = descriminator;
                        checkedProperty['subDiscriminatorName'] = subDiscriminator;
                    }
                } else {
                    checkedProperty = self.getCurrentCheckedProperties();
                    if (arrayUtil.isNotEmptyArray(checkedProperty)) {
                        checkedProperty = checkedProperty[0];
                        checkedProperty['discriminatorName'] = descriminator;
                    }
                }
            } else {
                checkedProperty = data[currentState.messageName] && getCheckedPropertiesFromList(data[currentState.messageName].properties);
                if (arrayUtil.isNotEmptyArray(checkedProperty)) {
                    checkedProperty = checkedProperty[0];
                }
            }
            return checkedProperty;
        };

        /**
         * Resets all properties for the given messageName.
         * If the message has discriminators or subdiscriminators, all will be unchecked.
         * @param messageName
         */
        self.resetProperties = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            if (self.hasDiscriminator(messageName)) {
                if (self.hasSubDiscriminator(messageName)) {
                    var discriminators = self.getDiscriminatorList(messageName);

                    discriminators.forEach(function (discriminator) {
                        discriminator.subDiscriminators.forEach(function (subDiscriminator) {
                            self.uncheckProperties(subDiscriminator.properties);
                            self.removePropertyIndex(subDiscriminator.properties);
                        });
                    });
                } else {
                    self.getDiscriminatorList(messageName).forEach(function (discriminator) {
                        self.uncheckProperties(discriminator.properties);
                        self.removePropertyIndex(discriminator.properties);
                    });
                }
            } else {
                const messageData = self.getMessageData(messageName);
                messageData && self.uncheckProperties(messageData.properties);
                messageData && self.removePropertyIndex(messageData.properties);
            }
            self.setEnableApply();
        };

        /**
         * Unchecks the properties in the given property list.
         * @param properties
         */
        self.uncheckProperties = function (properties) {
            properties.forEach(function (entry) {
                entry.checked = false;
            });
            self.setEnableApply();
        };

        /**
         * Remove the index field for each of the given properties.
         *
         * @param properties
         */
        self.removePropertyIndex = function (properties) {
            properties.forEach(function (entry) {
                delete entry.index;
            });
        };


        /**
         * Returns all the checkedProperties for the given messageName,
         * if no messageName is specified, the messageName for the currentState will be used.
         * @param messageName
         * @returns {Array}
         */
        self.getCheckedProperties = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            if (self.hasDiscriminator(messageName)) {
                if (self.hasSubDiscriminator(messageName)) {
                    var discriminators = self.getDiscriminatorList(messageName);
                    var checkedProperties = [];
                    discriminators.forEach(function (discriminator) {
                        //important to use getSubDiscriminatorList otherwise aggregation is ignored.
                        checkedProperties = checkedProperties.concat(getCheckedPropertiesArrayForList(self.getSubDiscriminatorList(messageName, discriminator.name), 'subid', 'name'));
                    });
                    return checkedProperties;
                } else {
                    return getCheckedPropertiesArrayForList(self.getDiscriminatorList(messageName), 'name');
                }
            } else {
                return getCheckedPropertiesFromList(self.getMessageData(messageName) ? self.getMessageData(messageName).properties : []);
            }
        };

        /**
         * Checks properties based on the given property for the current messageName.
         * This function will be used when we want to select for all discriminators or all subdiscriminators.
         * @param property
         * @param allDiscriminators
         * @param allSubDiscriminators
         */
        self.checkProperties = function (property, allDiscriminators, allSubDiscriminators) {
            if (self.hasDiscriminator()) {
                if (self.hasSubDiscriminator()) {
                    if (allDiscriminators) {
                        if (allSubDiscriminators) {
                            self.getDiscriminatorList().forEach(function (discriminator) {
                                discriminator.subDiscriminators.forEach(function (subDiscriminator) {
                                    var entry = arrayUtil.getFirstInList(subDiscriminator.properties, 'name', property.name);
                                    entry.checked = property.checked;
                                });
                            });
                        }
                    } else {
                        if (allSubDiscriminators) {
                            var discriminator = self.getDiscriminator();
                            discriminator.subDiscriminators.forEach(function (subDiscriminator) {
                                var entry = arrayUtil.getFirstInList(subDiscriminator.properties, 'name', property.name);
                                entry.checked = property.checked;
                            });
                        }
                    }
                } else {
                    if (allDiscriminators) {
                        var discriminators = self.getDiscriminatorList();
                        discriminators.forEach(function (discriminator) {
                            var entry = arrayUtil.getFirstInList(discriminator.properties, 'name', property.name);
                            entry.checked = property.checked;
                        });
                    }
                }
            }
            self.setEnableApply();
        };

        self.getTemplate = function () {
            var messageNames = self.getMessageNamesWithSelectedProperties();
            var template = {};

            messageNames.forEach(function (messageName) {
                template[messageName] = angular.copy(self.getCheckedProperties(messageName));
            });
            return template;
        };

        self.setTemplate = function (template) {
            var messageNames = self.getMessageNamesWithSelectedProperties();
            messageNames.forEach(function (messageName) {
                self.resetProperties(messageName);
            });

            for (var name in template) {
                if (template.hasOwnProperty(name)) {
                    var selectedProperties = template[name];
                    selectedProperties.forEach(function (property) {
                        var discriminatorName = property.discriminatorName;
                        var subDiscriminatorName = property.subDiscriminatorName;

                        var foundProperty = arrayUtil.getFirstInList(self.getProperties(name, discriminatorName, subDiscriminatorName), 'name', property.name);
                        angular.copy(property, foundProperty);
                    });
                }
            }
        };

        /**
         * Used to transfer old templates to the new structure.
         * @param template
         */
        self.setTemplateOld = function (template) {
            for (var name in template) {
                if (template.hasOwnProperty(name)) {
                    var templateData = template[name];
                    if (self.hasDiscriminator(name)) {
                        if (self.hasSubDiscriminator(name)) {
                            templateData.discriminators.forEach(function (discriminator) {
                                var discriminatorName = discriminator.name;
                                discriminator.subDiscriminators.forEach(function (subDiscriminator) {
                                    var subDiscriminatorName = subDiscriminator.name;
                                    subDiscriminator.properties.forEach(function (property) {
                                        var foundProperty = arrayUtil.getFirstInList(self.getProperties(name, discriminatorName, subDiscriminatorName), 'name', property.name);
                                        angular.copy(property, foundProperty);
                                    });
                                });
                            });
                        } else {
                            templateData.discriminators.forEach(function (discriminator) {
                                var discriminatorName = discriminator.name;
                                discriminator.properties.forEach(function (property) {
                                    var foundProperty = arrayUtil.getFirstInList(self.getProperties(name, discriminatorName), 'name', property.name);
                                    angular.copy(property, foundProperty);
                                });

                            });
                        }
                    } else {
                        templateData.properties.forEach(function (property) {
                            var foundProperty = arrayUtil.getFirstInList(self.getProperties(name), 'name', property.name);
                            angular.copy(property, foundProperty);
                        });
                    }
                }
            }
        };

        /**
         * Optional messageName, if none is specified the function is applied on the current messageName.
         * @param messageName
         * @returns {Function|*|boolean}
         */
        self.hasDiscriminator = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return data[messageName] && data[messageName].hasDiscriminator;
        };

        /**
         * Optional messageName, if none is specified the function is applied on the current messageName.
         * @param messageName
         * @returns {Function|*|boolean}
         */
        self.hasSubDiscriminator = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return data[messageName].hasSubDiscriminator;
        };

        /**
         * Optional messageName, if none is specified the function is applied on the current messageName.
         * @param messageName
         * @returns {string|string|string|*}
         */
        self.getDiscriminatorField = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return data[messageName].discriminatorField;
        };

        /**
         * Optional messageName, if none is specified the function is applied on the current messageName.
         * @param messageName
         * @returns {string|*}
         */
        self.getSubDiscriminatorField = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return data[messageName].subDiscriminatorField;
        };

        self.setInitialState = function (messageName) {
            self.showNoData =false;
            if (currentState.messageName === messageName) {
                return;
            }
            var newState = {
                messageName: undefined,
                discriminator: undefined,
                subDiscriminator: undefined,
                config: undefined
            };
            if (self.hasDiscriminator(messageName)) {

                if (!util.isDefined(self.getMessageData(messageName).discriminators) || self.getMessageData(messageName).discriminators.length === 0) {
                    self.showNoData =true;
                    // alert('no discriminators')  TODO put a non-blocking notification
                    return;
                }

                if (self.hasSubDiscriminator(messageName)) {
                    newState.discriminator = self.getMessageData(messageName).discriminators[0].name;
                    newState.subDiscriminator = self.getDiscriminator(messageName, newState.discriminator).subDiscriminators[0].name;
                } else {
                    newState.discriminator = self.getMessageData(messageName).discriminators[0].name;
                    newState.subDiscriminator = undefined;
                }
            } else {
                newState.discriminator = undefined;
                newState.subDiscriminator = undefined;
            }
            newState.messageName = messageName;
            newState.config = determineDiscriminatorConfig(messageName, self.mar3MessageNames, self.coachMessageNames);

            currentState = newState;
            self.setEnableApply();
        };

        self.setRate = function (rate, messageName) {
            messageName = arguments.length === 2 ? messageName : currentState.messageName;
            self.getMessageData(messageName).rate = rate;
        };

        self.getRate = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return self.getMessageData(messageName).rate;
        };

        self.getUseRate = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return self.getMessageData(messageName).useRate;
        };


        self.shouldAggregateVlinks = function (messageName) {
            //if this message supports link aggregation or not.
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            return util.isDefined(self.getMessageData(messageName)) && !!self.getMessageData(messageName).aggregateVlinks;
        };

        self.disableAggregateVlinks = function (messageName) {
            messageName = arguments.length === 1 ? messageName : currentState.messageName;
            if (util.isDefined(self.getMessageData(messageName).aggregateVlinks)) {
                currentState.aggregateLinks = false;
            }
        };

        self.getMessageNamesWithSelectedProperties = function () {
            var messageNames = [];
            for (var name in data) {
                if (data.hasOwnProperty(name)) {
                    var properties = self.getCheckedProperties(name);

                    if (properties && properties.length > 0) {
                        messageNames.push(name);
                    }
                }
            }
            return messageNames;
        };

        self.filterDiscriminators = function (discInfo, messageNames) {
            filterDiscriminators(self.getData(), discInfo, messageNames);
        };

        self.setConfig = function (config) {
            currentState.config = config;
        };

        self.getConfig = function () {
            return currentState.config;
        };

        var getCheckedPropertiesFromList = function (list) {
            var checkedProperties = [];

            list.forEach(function (entry) {
                if (util.isChecked(entry)) {
                    checkedProperties.push(entry);
                }
            });

            return checkedProperties;
        };

        var getCheckedPropertiesArrayForList = function (data, discriminatorName, subDiscriminatorName) {
            var checkedProperties = [];
            data.forEach(function (entry) {
                var properties = getCheckedPropertiesFromList(entry.properties);
                properties.forEach(function (property) {
                    if (util.isDefined(discriminatorName)) {
                        property['discriminatorName'] = entry[discriminatorName];
                    }
                    if (util.isDefined(subDiscriminatorName)) {
                        property['subDiscriminatorName'] = entry[subDiscriminatorName];
                    }
                });
                //todo
                checkedProperties = checkedProperties.concat(properties);
            });
            return checkedProperties;
        };

        return self;
    };

    function extractNonVlinks(discriminatorNames) {
        var discriminators = angular.copy(discriminatorNames);
        discriminators.forEach(function (discr) {
            var filtered = [];
            if (util.isDefined(discr[1])) {
                discr[1].forEach(function (sub) {
                    if (sub.indexOf("VLINK") === -1) {
                        filtered.push(sub);
                    }
                });
                discr[1] = filtered;
            }
        });
        return discriminators;
    }

    function determineDiscriminatorConfig(messageName, mar3MessageNames, coachMessageNames) {
        if (mar3MessageNames.indexOf(messageName) > -1) {
            return "mar3";
        }
        else if (coachMessageNames.indexOf(messageName) > -1) {
            return "coach";
        }
        return undefined;
    }

    function filterDiscriminators(data, discriminationInfo, messageNames) {

        if (util.isDefined(discriminationInfo) && !arrayUtil.isEmpty(discriminationInfo.discriptorList)) {
            var discriminatorNames = messageFields.discriptorsTo2DArray(discriminationInfo.discriptorList);

            messageNames.forEach(function (messageName) {
                var messageField = data[messageName];

                if (util.isDefined(messageField)) {
                    var copy = angular.copy(messageField);
                    var description = copy.description;
                    if (util.isDefined(description)) {

                        //simple values per box
                        // a descriminator is defined, but no subdiscriminator
                        if (description.isArray && (!util.isDefined(description.isSubDiscriminator) || !description.isSubDiscriminator)) {
                            discriminatorNames.forEach(function (name) {
                                description.discriminatorNames.push(name[0]);
                            });
                        } else {
                            //non simple values per box per link.
                            // just copy the given discriminator names

                            //mar3 congestion are statistics only per physical modem. No vlinks.
                            if (util.isDefined(description.hideVlinks)) {
                                discriminatorNames = extractNonVlinks(discriminatorNames);
                            }

                            description.discriminatorNames = discriminatorNames;
                        }

                        data[messageName] = messageFields.convertDescriptionToStructure(description);

                    }
                }
            });
        }
    }

    return MessageDataStructure;
};
